import { useTheme, type ThemePref } from '../theme'
import { IconAuto, IconMoon, IconSun } from './icons'

const OPTIONS: { value: ThemePref; label: string; Icon: typeof IconSun }[] = [
  { value: 'light', label: '라이트', Icon: IconSun },
  { value: 'dark', label: '다크', Icon: IconMoon },
  { value: 'system', label: '시스템 설정 따르기', Icon: IconAuto },
]

/**
 * 라이트·다크·시스템 3단 스위치. tone="ink" 는 항상 어두운 바(콘솔 상단 바) 위에 놓일 때.
 * vertical 은 접힌 사이드바처럼 폭이 좁은 자리에 세로로 쌓을 때.
 */
export default function ThemeToggle({ tone = 'plain', vertical = false }: { tone?: 'plain' | 'ink'; vertical?: boolean }) {
  const { pref, setPref } = useTheme()
  const frame = tone === 'ink' ? 'bg-white/8 ring-1 ring-white/10' : 'bg-gray-200/70'
  return (
    <div role="radiogroup" aria-label="화면 테마" className={`inline-flex ${vertical ? 'flex-col' : ''} rounded-lg p-0.5 ${frame}`}>
      {OPTIONS.map(({ value, label, Icon }) => {
        const on = pref === value
        const look = tone === 'ink'
          ? on ? 'bg-white/15 text-white' : 'text-white/50 hover:text-white/85'
          : on ? 'bg-surface text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'
        return (
          <button key={value} type="button" role="radio" aria-checked={on} title={label} aria-label={label}
            onClick={() => setPref(value)}
            className={`grid place-items-center w-7 h-6 rounded-md transition-colors ${look}`}>
            <Icon className="w-3.5 h-3.5" />
          </button>
        )
      })}
    </div>
  )
}
